import Vue from "vue";
import VueCurrencyInput from "vue-currency-input";
import Helper from "./helper";
import Faker from "./faker";
import Lodash from "./lodash";
import Api from "./api";

Vue.use(Helper);
Vue.use(Faker);
Vue.use(Lodash);
Vue.use(Api);
Vue.use(VueCurrencyInput, {
  globalOptions: {
    currency: {
      prefix: ""
    },
    precision: 0
  }
});
